<template>
<div class="w-full lg:w-1/3 sm:w-1/2 sm:p-2 p-4 my-2 cursor-pointer">
    <div class="rounded overflow-hidden shadow-lg w-full">
        <img @click="
              $router.push({
                name: 'learner-home',
                params: { course_id: course.id },
              })
            " v-if="hasPaid" class="w-full h-48 object-cover cursor-pointer" :src="courseImage" alt="EDCLearn Course" />
        <img @click="navigate(course.id)" v-else class="w-full h-48 object-cover cursor-pointer" :src="courseImage" alt="EDCLearn Course" />
        <div class="px-6 py-4">
            <div class="program-main mb-2 tenant-main-color" @click="navigate(course.id)">
                {{ course.title }}
            </div>
            <p class="program-content text-gray-700 text-base">
                {{ course.caption }}
            </p>
            <div class=" program-content flex flex-wrap tenant-main-color my-2 justify-between">
                <!--<span v-if=" typeof course.course_video !== 'undefined' " class="cursor-pointer" @click="playVideo">Watch Video</span>-->
                <div></div>
            </div>
<!--            <div v-if="!hasPaid" class="flex justify-between flex-wrap">-->
<!--                <div v-if="course.course_subscription_type === 'specify'">-->
<!--                    <lms-button v-if="!courseInCart && course.payment_type !== 'free'" @click="addToCart" class="my-1">Enroll</lms-button>-->
<!--                    <lms-button v-if="!courseInCart && course.payment_type == 'free'" @click="addToCart" class="my-1">Enroll Free</lms-button>-->
<!--                </div>-->
<!--                <div v-if="course.course_subscription_type === 'inherit'">-->
<!--                    <lms-button v-if="!courseInCart && course.subscription.subscription_type !== 'free' && course.subscription.subscription_type !== 'bulk'" @click="addToCart" class="my-1">Enroll</lms-button>-->
<!--                    <lms-button v-if="!courseInCart &&  course.subscription.subscription_type === 'free' " @click="addToCart" class="my-1">Enroll Free</lms-button>-->
<!--                    <lms-button v-if="!courseInCart &&  course.subscription.subscription_type === 'bulk' " @click="processPayment(course.program_id,course.subscription.subscription_cost)" class="my-1">Bulk Enroll</lms-button>-->
<!--                </div>-->

<!--                <lms-button v-if="courseInCart" @click="$router.push({ name: 'learner-cart' })" style="background: green">View in Cart</lms-button>-->
<!--                <lms-outline-button @click="addToWishList" class="my-2" v-if="!courseInWishList" :color="this.colorTheme">-->
<!--                    <i class="far fa-heart"></i> Wishlist-->
<!--                </lms-outline-button>-->
<!--                <lms-button v-else @click="$router.push({ name: 'learner-wishlist' })" style="background: green">View in WishLists</lms-button>-->
<!--            </div>-->
            <div v-if="course.progress < 100  && course.has_repay !== null && !course.has_repay.locked" class="flex justify-between flex-wrap">
                <lms-button @click="
              $router.push({
                name: 'learner-enrolled-courses',
                // params: { course_id: course.id },
              })
            " class="my-1">Visit My Courses</lms-button>

                <lms-button @click="navigate(course.id)" class="my-1"> Details</lms-button>
            </div>
            <div v-else-if="course.progress < 100 && hasPaid && course.has_repay !== null && course.has_repay.locked" class="flex justify-between flex-wrap">
                <lms-button class="my-1">Repay</lms-button>

                <lms-button @click="navigate(course.id)" class="my-1"> Details</lms-button>
            </div>
            <div v-if="course.progress >= 100" class="flex justify-between flex-wrap">
                <lms-button @click="
              $router.push({
                name: 'learner-home',
                params: { course_id: course.id },
              })
            " class="my-1">Course Completed</lms-button>

                <lms-button @click="navigate(course.id)" class="my-1"> Details</lms-button>
            </div>
        </div>
    </div>

    <modal @click="hide" :name="'overview-video' + course.id">
        <Media kind="video" :controls="true" :src="course.course_video" :style="{ width: '100%' }">
        </Media>

    </modal>
</div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
import {
    mapActions,
    mapGetters
} from "vuex";
import SettingsMixin from "@/mixins/SettingsMixin";
import FormActions from "@/mixins/FormActions";
export default {
    mixins: [FormActions,SettingsMixin],
    props: {
        course: {},
    },
    data() {
        return {
            paidCourses: this.$store.state.learner.courses,
        };
    },
    components: {
        LmsButton: () => import("@/components/general/button"),
        LmsOutlineButton: () => import("@/components/general/outline_button"),
        Media,
    },
    methods: {
        ...mapActions([
            "learnerAddToCart",
            "fetchCourseLessons",
            "learnerAddToWishlist",
            "learnerPurchaseProgram"
        ]),
        nairaToKobo(amount) {
            return (amount * 100).toFixed(0);
        },
        navigate(id) {
            this.$router.push({
                name: "learner-single-course",
                params: {
                    id: id
                }
            });
        },
        playVideo() {
            this.$modal.show("overview-video" + this.course.id);
        },
        async purchaseProgram(programId, amount) {
            let res = await this.learnerPurchaseProgram({
                programId: programId,
                amount: amount
            })
            if (res.status === 201 || res.status === 200) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Transaction Successful",
                });
                this.$router.push({
                    name: 'learner-enrolled-courses',
                })
            } else {
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.data.title,
                });
            }
        },
        async addToCart() {
            this.learnerAddToCart({
                ...this.course,
            });
            await this.$swal({
                title: "Item Successfully Added to Cart",
                cancelButtonText: "Continue Shopping",
                confirmButtonText: "Go To Cart",
                showCancelButton: true,
            }).then((res) => {
                if (res.isConfirmed) {
                    this.$router.push({
                        name: "learner-cart"
                    });
                }
            });
        },
        async addToWishList() {
            this.learnerAddToWishlist({
                ...this.course,
            });
            await this.$swal({
                title: "Item Successfully Added to WishList",
                cancelButtonText: "Continue Shopping",
                confirmButtonText: "Go To WishList",
                showCancelButton: true,
            }).then((res) => {
                if (res.isConfirmed) {
                    this.$router.push({
                        name: "learner-wishlist"
                    });
                }
            });
        },
        hide() {
            this.$modal.hide("overview-video" + this.course.id);
        },
        processPayment(programId, amount) {
            let that = this;
            let handler = PaystackPop.setup({
                key: "pk_live_921e367ae8e08ed0badd3b7081af68c7c0c49fdb",
                email: this.user.email,
                amount: this.nairaToKobo(parseFloat(amount)),
                channels: ["card", "bank", "ussd"],
                metadata: {
                    custom_fields: [{
                        user_name: this.user.first_name,
                        variable_name: this.user.phone_number,
                    }, ],
                },
                callback: function (response) {
                    that.ref = response.reference;
                    that.purchaseProgram(programId, amount)
                },
                onClose: function () {
                    //console.log("window closed");
                },
            });
            handler.openIframe();
        }
    },
    computed: {
        ...mapGetters({
            cart: "getLearnerCart",
            wishlist: "getLearnerWish",
            user: "getUser",
            settings: "getSettings"
        }),
        courseInCart() {
            return Object.keys(this.cart).includes(this.course.id);
        },
        courseImage() {
             return this.course.course_image;
            // let course_image = this.course.course_image
            // if (course_image) {
            //     if (course_image.includes(process.env.VUE_APP_TENANT_BUCKET)) {
            //         let replacement = "https://media.edclearn.com";
            //         if (this.settings.data_bypass) {
            //             replacement = "https://media.main.edclearn.com";
            //         }
            //         var parts = course_image.split('.com', 2);
            //         return replacement + parts[1];
            //     } else {
            //         return course_image
            //     }
            // }
        },
        courseInWishList() {
            return this.wishlist.some(wish => {
                return wish.course.id === this.course.id
            });
        },
        hasPaid() {
            return typeof this.paidCourses[this.course.id] === "object";
        },
    },
    mounted() {
        const payPopup = document.createElement("script");
        payPopup.setAttribute("src", "https://js.paystack.co/v2/inline.js");
        payPopup.async = true;
        document.head.appendChild(payPopup);
    }
};
</script>

<style lang="css" scoped>
.program-main {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
}
.program-content {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
}
</style>
